class AnchorNav extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll('a[href^="#"]'));
    this.targets = this.links
      .map((link) => document.getElementById(link.getAttribute('href').slice(1)))
      .filter(Boolean);

    if (this.targets.length === 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const link = this.links.find((l) => l.getAttribute('href') === `#${entry.target.id}`);
          if (!link) return;
          this.links.forEach((l) => l.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'page');
        });
      },
      { rootMargin: '-40% 0px -40% 0px' }
    );

    this.targets.forEach((target) => this.observer.observe(target));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('anchor-nav', AnchorNav);
